import { render, staticRenderFns } from "./AnalisiRischiThView.vue?vue&type=template&id=44c1a590&scoped=true"
import script from "./AnalisiRischiThView.vue?vue&type=script&lang=js"
export * from "./AnalisiRischiThView.vue?vue&type=script&lang=js"
import style0 from "./AnalisiRischiThView.vue?vue&type=style&index=0&id=44c1a590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c1a590",
  null
  
)

export default component.exports